
import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../../services/timesheetreportsService';
import {timesheetService} from '../../services/timesheetService';
import {formatterhelper} from '../../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import {loader} from '../../compnents/loadermd';
import {Nodatacomp,Nodataprimecomp} from '../../compnents/nodatacomp';
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { Dialog } from 'primereact/dialog';
import { timesheetuserService } from '../../services/timesheetUserservice';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import { FaBeer, FaCheck, FaEdit, FaLock, FaRecycle, FaSearch, FaStar, FaUnlock,FaTrashAlt,FaPlusCircle,FaTrash,FaCheckCircle, FaDatabase } from "react-icons/fa";

import {dataExporthelper} from '../../helpers/exporthelper';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { ToggleButton } from 'primereact/togglebutton';
import '../finalbillapproval.css';
var XLSX = require("xlsx");

const Finalbillapproval = () => {
    
    const toast = useRef(null);
    const [formData, setFormData] = useState({
        date: '',
        client: 'ALL',
        services: '',
      });
    const [datacomp,setDatacomp] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [cleintscomp,setClientscomp] = useState([]); 
    const [cleintscomptemp,setClientscomptemp] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [empcomp,setempcomp] = useState([]); 
    const [userscomp,setuserscomp] = useState([]);
    const [userslists,setuserslists] = useState([]); 
    const [totalpages,setPages] = useState(0);
    const [filterobj,setfilterobj] = useState({});
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const roledata = localStorage.getItem('role') != '' ? JSON.parse(localStorage.getItem('role')) : {};
    const [isloaded,setloading] = useState(true);
    const [isuserloaded,setuserloading] = useState(true);
    const [dialogtoggle,setdialogtoggle] = useState(false);
    
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [currentpage, setCurrpage] = useState(1);
    const [adjustments, setAdjustments] = useState([]);
    const [userslistcomp, setUserslistscomp] = useState([]);
    const [clientloaded, setClientloading] = useState(true);
    const [reportslists, setReportslists] = useState([]);
    const [reportsliststemp, setReportsliststemp] = useState([]);
    // const [reportslists, setReportslists] = useState([]);
    const [valuedataarr, setvaluedataarr] = useState([]);
    const [wholevaluedataarr, setwholevaluedataarr] = useState([]);
    const [checkdataarraylist,setcheckarraylists] = useState([]);
    
    var checkeddataarray = [];
    var checkeddataarray2 = [];
    const [actualhours,setactulahrs] = useState(0);
    const [approvaldata,setapprovaldata] = useState({'approved':'','locked':'','notapproved':'','unlocked':'','actualhours':'','sumbilledhrs':'','finalbillhrs':'','lockedhours':'','unlockedhours':''});
    let manulaobj = {'client':"","budget":''}; 
    const [manauladata,setmanualdata] = useState(manulaobj); 
    const [billingtypevar,setbillingtype] = useState('Budget');
    const [errors, setErrors] = useState({});
    const auobj = {"id":"","client":"","subclient":"",
    "actualhr":0,"billedhr":0,"budgetmin":0,"finalbillhr":0,"remarkscomment":'',"remarks":"","services":"Bookkeeping","approvedfor":"","islocked":"","date":'',"billingtypemodel":"","sumactualhrs":"","sumbilledhrs":"","finalbillhrs":""}; 
    const [autoobj,setAutoobj] = useState([auobj]);
    const [cleintscompid,setClientscompid] = useState([]); 
    const [ismulticheckeddata, setMulticheckeddata] = useState([]);
    const [ismulticheckeddata2, setMulticheckeddata2] = useState([]);
    const [ismulticheckeddata3, setMulticheckeddata3] = useState([]);
    const [autofilterobj,setfilterAutoobj] = useState({});
    const [islockeddataislocked,setislockeddataislocked] = useState({'lock':false,'unlock':false});
    const [manualfinalbill,setManualfinalbill] = useState({'finalbillhr':0});
    const [datevalue,setDatevalue] = useState('');

     useEffect(()=>{
        // console.log(filterobj.length);
        if((Object.keys(filterobj).length == 0) == false){
            // getfinalbillapproval({objdata:filterobj});
        }else{
            _getclientslist();
        }
    },[currentpage]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));

        if(name == 'date'){
            setDatevalue(value);
        }

        if(name == 'services'){
            setReportslists([]);
            checkeddataarray2 = [];
            checkeddataarray = [];
        }
    };

    const validateForm = () => {
        let valid = true;
        const newErrors = {};
        
        if (formData.date == '') {
            newErrors.date = 'Field is required';
            valid = false;
          }

        if (formData.client == '') {
          newErrors.client = 'Field is required';
          valid = false;
        }

        if (formData.services == '') {
            newErrors.services = 'Field is required';
            valid = false;
          }

        setErrors(newErrors);
       return valid; 
    }  

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if(!validateForm()){
             return; 
        }

        let date = formatterhelper.dateformatter({date:formData.date});
        setloading(false);

        let objdata = {
           'date':date,    
           'client':formData.client,
           'services':formData.services
        }; 
        setfilterobj(objdata);
        getfinalbillapproval({objdata:objdata});
        getclientwisebudget({objdata:objdata});
        getmanualdata();
   };

   const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    let pageno = 1;
    if(event.first == 0){
     pageno = 1;    
    }else{
     pageno = ((event.first/rows) + 1);  
    }
    // console.log(pageno);
    setCurrpage(pageno);
    console.log("page chnaged");
   };

   function getfinalbillapproval({objdata}){
    setloading(false);
    setfilterAutoobj(objdata);
    let obj = JSON.stringify(objdata);
    timesheetreportService.getfinalbillapproval({formdata:obj}).then((response)=>{
        if(response.status == 200){
            // console.log(response);
            setReportslists(response.data.data);
            setReportsliststemp(response.data.data);
            setapprovaldata(response.data);
            setislockeddataislocked({'lock':false,'unlock':false});
            // setPages(response.data.data.total);
        }else{
            setReportslists([]);  
            setReportsliststemp([]);
        }
        setloading(true);
        setDatastate(true);
    }).catch((error)=>{
        // console.log("error");
        // console.log(error); 
        setReportslists([]);
        setReportsliststemp([]);
        setloading(true);
        setDatastate(true);
    });
   }

   
    function saveremarks(index,value){
        // console.log(index);
        // console.log(value);
        let obj = {'data':value};
        obj = JSON.stringify(obj);
        timesheetService.saveremarks({formdata:obj}).then((response)=>{
            //  console.log(response);
             if(response.status == 200){
                toast.current.show({severity:'success', summary: "Final approval", detail:`Remark saved`, life: 3000});  
             }else{
                toast.current.show({severity:'error', summary: "Final approval", detail:`Not saved`, life: 3000});   
             } 
        }).catch((error)=>{
            toast.current.show({severity:'error', summary: "Final approval", detail:`Error`, life: 3000});  
        }); 
    }

    function checkeddataapproved(e,key,index){
            // console.log("event target");
            console.log("check data approved 123");
            try{
                console.log(index);
                console.log("checeked data approved ");
                let newindex = index;
                if (e.target.checked) {
                    // Checkbox is checked
                    key.index = index;

                    const newIsMulticheckedData = [...ismulticheckeddata];
                    newIsMulticheckedData[index] = true;
                    setMulticheckeddata(newIsMulticheckedData);

                    console.log("checked ");
                  } else {
                    // Checkbox is unchecked

                    const newIsMulticheckedData = [...ismulticheckeddata];
                    newIsMulticheckedData[index] = false;
                    setMulticheckeddata(newIsMulticheckedData);
                }
            }catch(error){
               console.log(error);
            }
           
    }

    function checkeddatafinance(e,key,index){
        if (e.target.checked) {
            if (islockeddataislocked.lock || ismulticheckeddata2.some(v => v === true)) {
                toast.current.show({ severity: 'warn', summary: 'Not Allowed', detail: 'Lock rows are already selected. Uncheck all Lock rows before selecting Unlock rows.', life: 3000 });
                return;
            }
            setislockeddataislocked({'lock':false,'unlock':true});
            const newIsMulticheckedData = [...ismulticheckeddata3];
            newIsMulticheckedData[index] = true;
            setMulticheckeddata3(newIsMulticheckedData);
        } else {
            const newIsMulticheckedData = [...ismulticheckeddata3];
            newIsMulticheckedData[index] = false;
            setMulticheckeddata3(newIsMulticheckedData);
            const anyStillChecked = newIsMulticheckedData.some(v => v === true);
            if (!anyStillChecked) setislockeddataislocked({'lock':false,'unlock':false});
        }
    }

    function ismultichecked(e){
        if (e.target.checked) {
            // Checkbox is checked
            let checkdatabox1 = [];
            reportslists.forEach((values,index)=>{
                if(values.approvedfor == 'step1'){
                    checkdatabox1[index] = true; 
                    ismulticheckeddata[index] = true;
                    checkeddataarray.push(values);
                }
            });
            setcheckarraylists(checkeddataarray);
            setMulticheckeddata(ismulticheckeddata);
        } else {
            checkeddataarray  = [];
            let checkdatabox1 = [];
            reportslists.forEach((values,index)=>{
                checkdatabox1[index] = false;   
                ismulticheckeddata[index] = false; 

            });
            setcheckarraylists([]);
            setMulticheckeddata(ismulticheckeddata);
        }
    }

    function ismultilockchecked(e){
        if (e) {
            if (islockeddataislocked.unlock) {
                toast.current.show({ severity: 'warn', summary: 'Not Allowed', detail: 'Unlock is already active. Uncheck Unlock before selecting Lock.', life: 3000 });
                return;
            }
            setislockeddataislocked({lock:true, unlock:false});
            setMulticheckeddata3([]);
            const newIsMulticheckedData = [];
            reportslists.forEach((values, index) => {
                newIsMulticheckedData[index] = (values.approvedfor == 'step2' && values.islocked == 'no');
            });
            setMulticheckeddata2(newIsMulticheckedData);
        } else {
            setislockeddataislocked({lock:false, unlock:false});
            setMulticheckeddata2([]);
        }
    }

    function ismultilockchecked2(e){
        if (e) {
            if (islockeddataislocked.lock) {
                toast.current.show({ severity: 'warn', summary: 'Not Allowed', detail: 'Lock is already active. Uncheck Lock before selecting Unlock.', life: 3000 });
                return;
            }
            setislockeddataislocked({unlock:true, lock:false});
            setMulticheckeddata2([]);
            const newIsMulticheckedData = [];
            reportslists.forEach((values, index) => {
                newIsMulticheckedData[index] = (values.approvedfor == 'step2' && values.islocked == 'yes');
            });
            setMulticheckeddata3(newIsMulticheckedData);
        } else {
            setislockeddataislocked({lock:false, unlock:false});
            setMulticheckeddata3([]);
        }
    }

    function multiapprove(){
        // console.log(ismulticheckeddata);
        let temarr = [];
        ismulticheckeddata.forEach((values,index)=>{
           if(values == true){
                temarr.push(index);
           }
        });

        let itemarr = [];
           
        temarr.forEach((values,index)=>{
            let founditem = reportslists.at(values);
        
            itemarr.push(founditem);
        });

        let obj = {
             'data':itemarr,
             'type':formData.services
        };
        obj = JSON.stringify(obj);
        timesheetService.multifinalapprove({formdata:obj}).then((response)=>{
           if(response.status == 200){
               toast.current.show({severity:'success', summary: "Final approval", detail:`Approved successfully`, life: 3000}); 
               getfinalbillapproval({objdata:filterobj});      
                   
           }else{
               toast.current.show({severity:'error', summary: "Final approval", detail:`Not Approved`, life: 3000}); 
           }   
        }).catch((error)=>{
            toast.current.show({severity:'error', summary: "Final approval", detail:`Error`, life: 3000});
        });

    }

    function sendtofinance(){
        checkeddataarray2.forEach((value,index)=>{
          value.billingtype = billingtypevar;  
        });

        console.log(checkeddataarray2); 

    }

    function ismultilocked(e,key,index){
        if(e.target.checked){
            if (islockeddataislocked.unlock || ismulticheckeddata3.some(v => v === true)) {
                toast.current.show({ severity: 'warn', summary: 'Not Allowed', detail: 'Unlock rows are already selected. Uncheck all Unlock rows before selecting Lock rows.', life: 3000 });
                return;
            }
            const newIsMulticheckedData = [...ismulticheckeddata2];
            newIsMulticheckedData[index] = true;
            setMulticheckeddata2(newIsMulticheckedData);
            setislockeddataislocked({'lock':true,'unlock':false});
        }else{
            const newIsMulticheckedData = [...ismulticheckeddata2];
            newIsMulticheckedData[index] = false;
            setMulticheckeddata2(newIsMulticheckedData);
            const anyStillChecked = newIsMulticheckedData.some(v => v === true);
            if (!anyStillChecked) setislockeddataislocked({'lock':false,'unlock':false});
        }
    }

    function lockmulti(){
         let temarr = [];
         if(islockeddataislocked.unlock){
            unlockmulti();
            return;
         }
        //  console.log(ismulticheckeddata2);
        //  return;
         ismulticheckeddata2.forEach((values,index)=>{
           if(values == true){
                temarr.push(index);
           }
        });

        let itemarr = [];
        temarr.forEach((values,index)=>{
            let founditem = reportslists.at(values);
        
            itemarr.push(founditem);
        }); 

       
        let obj = {
           'data':itemarr,
           'locktype':'lock',   
        }
        timesheetService.multilock(obj).then((response)=>{
            if(response.status == 200){
                setMulticheckeddata2([]);
                setislockeddataislocked({lock:false, unlock:false});
                getfinalbillapproval({objdata:autofilterobj});
            }
        }).catch((error)=>{
            getfinalbillapproval({objdata:autofilterobj});
        });

    }

    function unlockmulti(){
        let temarr = [];
        ismulticheckeddata3.forEach((values,index)=>{
          if(values == true){
               temarr.push(index);
          }
       });

       let itemarr = [];
       temarr.forEach((values,index)=>{
           let founditem = reportslists.at(values);
           itemarr.push(founditem);
       }); 

       let obj = {
          'data':itemarr,
          'locktype':'unlock',   
       }
       timesheetService.multilock(obj).then((response)=>{
           if(response.status == 200){
               setMulticheckeddata3([]);
               setislockeddataislocked({lock:false, unlock:false});
               getfinalbillapproval({objdata:autofilterobj});
           }
       }).catch((error)=>{
           getfinalbillapproval({objdata:autofilterobj});
       });

   }

    function  displaybkreport(){
        // let sumactualhours = 0; 
        try{
            let emparr = [];  
            reportslists.forEach((key,index)=>{
                // sumactualhours = key.sumactualhrs + sumactualhours;
                emparr.push((<tr>
                               <td>{index + 1}</td>
                             
                               <td>{key.client}</td>
                               <td>{key.subclient}</td>
                               <td>{key.sumactualhrs}</td>
                               <td>{key.sumbilledhrs}</td>
                               <td>{key.finalbillhrs}</td>
                               <td>{key.services}</td>
                               {formData.services == 'bk' ? (
                               <td>
                                 <div className='container-box'>
                                 <input type="text" className='form-control'  defaultValue={key.remarkscomment} 
                                 onChange={(e) => {key.remarkscomment = e.target.value}}
                                  />
                                 <button className='btn btn-light' onClick={() => saveremarks(index,key)}><FaCheck/></button>
                                 </div>
                                </td>) : (<></>)}
                               
                                {formData.services == 'bk' ? (<td>
                                    {billingtypevar}
                                 </td>) : (<></>)}
                                 <td>{key.islocked == 'yes' ? 'Locked' : 'Unlocked'}</td>
                               <td>
                                <div className='container-box align-item-hor container-align-hor'>
                                
                                {key.approvedfor == 'step2' ? ( <button className='btn btn-success' title="Send to Finance"><FaCheck/></button>) : (<button className='btn btn-warning' title='Single approve'  onClick={()=>finalapprove(key)}><FaCheck/></button>)}  
                                
                                  &nbsp;
                                 <button className='btn btn-light' onClick={() => isdatalocked(key)}>{key.islocked == 'yes' ? (<FaLock className='islocked' title="You can't edit this data right now. It's protected to keep it accurate. to edit Unlock it first"/>) : (<><FaUnlock className='error' title="Data is not locked yet"/></>)}</button>
                                 
                                 {(key.islocked != 'yes' && key.approvedfor == 'step2') ? (<input type='checkbox' title="Check and click on Send to finance" checked={ismulticheckeddata2[index]} className='checkbox-outline-border-red' onChange={(e) => {ismultilocked(e,key,index)}}/>) : (<></>)}
                                 &nbsp;
                                 {/* {key.approvedfor == 'step2' ? (<FaStar className='edit-btn-style'/>) : (<FaStar className='waiting'/>)}  */}

                                 {key.approvedfor != 'step2' ? <input type='checkbox' checked={ismulticheckeddata[index] == undefined ? false : ismulticheckeddata[index]}  className='checkbox-outline-border-orange' onChange={(e) => checkeddataapproved(e,key,index)}/> : (<></>)} 
                                 {key.islocked == 'yes' ? ( <input type='checkbox' checked={ismulticheckeddata3[index] == undefined ? false : ismulticheckeddata3[index]} title="Check and click on Send to finance" className='checkbox-outline-border-green' onChange={(e) => checkeddatafinance(e,key,index)}/>) : (<></>)}
                                  
                                </div>
                               </td>
                               <td>{key.workflowlock == 'yes' ? <FaLock className='islocked' title="You can't edit this data right now. It's protected to keep it accurate. to edit Unlock it first"/> : <FaUnlock className='error' title="Data is not locked yet"/>}</td>
                </tr>));
            }); 
            
            return emparr;
        }catch(error){
            console.log(error);    
        }
       
    }
  

    function _getclientslist(){
       
        let emparr = [];
        let emparrtemp = [];
        setClientloading(false);
        timesheetreportService.getclientslist().then((response)=>{
            // console.log(response.data.data);
            if(response.status == 200){
                response.data.data.forEach((value,index) =>{
                    if(value.client != ''){
                        emparr.push((<option value={value.id}>{value.client}</option>));         
                    }
                });
                setClientscomp(emparr);

                response.data.data.forEach((value,index) =>{
                    if(value.client != ''){
                        emparrtemp.push((<option value={value.client}>{value.client}</option>));         
                    }
                });
                setClientscomptemp(emparrtemp);
                setClientloading(true);
            }else{
                setClientloading(true); 
            }
            
         }).catch((error)=>{
            setClientloading(true); 
         });    
    }

    
    const exportexcel = () =>{
        exportToExcel();
    }

    function exportToExcel() {
        dataExporthelper.exportFromhtml({id:'finalaprovalbill-table-id',reportname:'Finalbillapproval',headerstart:0});
    }
   
   const handleAdjustmentChange = (index, newValue) => {
        const newAdjustments = [...adjustments];
        newAdjustments[index] = newValue;
        console.log(newAdjustments[index]);
        setAdjustments(newAdjustments);
    };

    
    function getusercomp(){
        try{
            let temcomp= [];
            userslists.forEach((value,index)=>{
                // adjustments[index] = value.adsadjustment; 
                temcomp.push((
                   (<tr key={index}>
                    <td scope="col">{value.usr_id}</td>
                    <td scope="col">{value.u_name}</td>
                    <td scope="col">{value.client}</td>
                    <td scope="col">{value.subclient}</td>
                    <td scope="col">{value.actualhrs}</td>
                    <td scope="col">{value.billed}</td>
                    <td scope="col">
                        <input
                        type="number"
                        className='form-control'
                        value={adjustments[index]}
                        onChange={(e) => handleAdjustmentChange(index, e.target.value)}
                        />
                    </td>
                    <td scope="col">Adjustment (Difference between Final billing to Billed Hrs as per timesheet)</td>
                    </tr>)     
                ));
            }); 
            return  temcomp;
        }catch(error){
            console.log(error);
           return []; 
        }
        
    }
    
    function finalapprove(value){
        // console.log(value);
        let tempobj = value;
        tempobj.datatype = value.type;
        // console.log(tempobj);
        let obj = {
            'data':tempobj,
            'type':formData.services
        };
        obj = JSON.stringify(obj);
        timesheetService.finalapprove({formdata:obj}).then((response)=>{
           if(response.status == 200){
                // console.log(response);
                toast.current.show({severity:'success', summary: "Final approve", detail:`Approved successfully`, life: 3000});
                getfinalbillapproval({objdata:filterobj});
           }else{
            //    console.log("response data");
               toast.current.show({severity:'error', summary: "Final approve", detail:`Not Approved`, life: 3000});
           }
        }).catch((error)=>{
            toast.current.show({severity:'error', summary: "Final approve", detail:`Error`, life: 3000});
        });
    }

    function isdatalocked(formdata){ 
        formdata.type = formdata.services; 
        formdata.updatetype = formdata.updatetype;
        let lockedmessage = 'Locked successfully'; 
        if(formdata.islocked == 'yes'){
            formdata.islocked = 'no'; 
            lockedmessage = 'UnLocked';
        }else{
            formdata.islocked = 'yes';
            lockedmessage = 'Locked';
        } 
        
       let tempobj = {
         'data':formdata
       }; 
       let obj = JSON.stringify(tempobj);
       timesheetService.isdatalocked({formdata:obj}).then((response)=>{
           if(response.status == 200){
            //    console.log('response');
               toast.current.show({severity:'success', summary: "Final approve", detail:`${lockedmessage}`, life: 3000});
               setMulticheckeddata([]);
               setMulticheckeddata2([]);
               setMulticheckeddata3([]);
               setislockeddataislocked({lock:false, unlock:false});
               getfinalbillapproval({objdata:filterobj});
           }else{
              toast.current.show({severity:'error', summary: "Final approve", detail:`${response.data.data}`, life: 3000});   
           }
       }).catch((error)=>{
          toast.current.show({severity:'error', summary: "Final approve", detail:`Error`, life: 3000});  
       });
    }

    function getclientwisebudget({objdata}){
         let obj = {
             'selectedclient':objdata.client,
             'month':objdata.date
         };
         obj = JSON.stringify(obj);
         timesheetService.getclientwisebudget({formdata:obj}).then((response)=>{
              console.log(response); 
              if(response.status == 200) {
                setmanualdata(response.data.data);
              }else{
                setmanualdata(manulaobj);
              }
         }).catch((error)=>{
            setmanualdata(manulaobj);
         });
    }

    function billingtype(e){
        //  console.log(e.target.value);
        setbillingtype(e.target.value);
        let type = e.target.value;
        
        const date = new Date(datevalue);
        // Format the date to YYYY-MM-DD
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const day = String(date.getDate()).padStart(2, '0');

        const formattedDate = `${year}-${month}-${day}`;
       
        timesheetService.updatebillingtype(formattedDate,type).then((response)=>{
           if(response.status == 200){
               toast.current.show({severity:'success', summary: "Final approve", detail:`Updated successfully`, life: 3000});
                  getbillingtype(formattedDate,type);
           }else{
               toast.current.show({severity:'error', summary: "Final approve", detail:`Not Updated`, life: 3000});          
           }  
        }).catch((error)=>{
             toast.current.show({severity:'error', summary: "Final approve", detail:`Error`, life: 3000});
        });
    }

    const getbillingtype = (date,type) => {
        timesheetService.getbillingtype(date,type).then((response)=>{
             if(response.status == 200){
                 // console.log("response ge billing type");
                 // console.log(response.data.data[0].billingtype);
                 setbillingtype(response.data.data[0].billingtype);   
             }
        }).catch((error)=>{
             
        });
    }

    const autoobjData = () =>{
        let objarr = [];
        autoobj.forEach((value,index)=>{
            objarr.push(<tr className='border-color'>
        <td scope="col">{value.id}</td>
        <td scope="col">
            <div className='container-box'>
                <input type="text" style={{width:'178px'}} disabled value={autoobj[index].client} className='form-control text-center'/>
                <select className='text-center' style={{width:'23px',border: '1px solid #ebebeb'}} name='client' value={autoobj[index].client} 
                onChange={(e)=> autochange(e,index)}
                >
                        <option value="">Select client</option>                  
                        {cleintscomptemp}
                </select>
            </div>
        </td>
        <td scope="col"><input type="text" name="subclient" onChange={(e)=> autochange(e,index)} value={value.subclient} className='form-control text-center'/></td>
        <td scope="col"><input type="number" name="actualhr" onChange={(e)=> autochange(e,index)} Value={value.actualhr} placeholder='actualhr' className='form-control text-center' defaultvalue="actualhr"/></td>
        <td scope="col"><input type="number" name="billedhr" onChange={(e)=> autochange(e,index)} Value={value.billedhr} placeholder='billedhr' className='form-control text-center' defaultvalue="billedhr"/></td>
        <td scope="col"><input type="number" name="finalbillhr" onChange={(e)=> autochange(e,index)} Value={value.finalbillhr} placeholder='finalbillhr' className='form-control text-center' defaultvalue="finalbillhr"/></td>
        <td>Bookkeeping</td>
        {formData.services == 'bk' ? (   
            <td>
                <div className='container-box'>
                <input type="text" className='form-control'  defaultValue={value.remarkscomment} 
                onChange={(e) => {value.remarkscomment = e.target.value}}
                />
                <button className='btn btn-light' onClick={() => saveremarks(index,value)}><FaCheck/></button>
                </div>
            </td>) : (<></>)}
        {/* <td scope="col"><input type="text" name="finalbillmin" onChange={(e)=> autochange(e,index)} Value={value.finalbillmin} className='form-control text-center' defaultvalue="finalbill"/></td> */}
        {formData.services == 'bk' ? 
        (<td>
            {value.billingtypemodel = billingtypevar}
            {/* {billingtypevar} */}
            </td>) : (<></>)}
        <td>{value.islocked == 'no' ? 'Unlocked' : 'Locked'}</td>
        
        
        {/* <td> </td> */}
        <td scope="col" colSpan="2">
            <div className='container-box space-between'>
            {value.id != '' > 0 ? (<>DB</>) : (<></>)}
            &nbsp;
            <FaCheckCircle className='edit-btn-style' style={{fontSize:'21px'}} onClick={() => saveautochange(value)}/>
            &nbsp;
            <FaPlusCircle className='info-style' style={{fontSize:'21px'}} onClick={() => addautoobj(value)}/>
            {/* <button className='btn btn-info' onClick={() => addautoobj()}><FaPlusCircle style={{color:'white'}}/></button> */}
            &nbsp;
            <FaTrash className='error' style={{fontSize:'21px'}} onClick={() => value.id.length <=0 ? removeautoobj(index) : removeautoobjdb(value) }/>
            {/* <button className='btn btn-danger' onClick={() => value.id.length <=0 ? removeautoobj(index) : removeautoobjdb(value) }><FaTrash/></button> */}
            </div>
        </td>
    </tr>);
    });
    return objarr;
    }

    function autochange(e,index){
        let newobj = [...autoobj];
        const { name, value } = e.target;
        if(name == 'client'){
            newobj[index].client = e.target.value;
        }
        if(name == 'subclient'){
            newobj[index].subclient = e.target.value;
        }
        if(name == 'actualhr'){
            newobj[index].actualhr = e.target.value;
        }

        if(name == 'billedhr'){
            newobj[index].billedhr = e.target.value;
        }

        if(name == 'finalbillhr'){
            newobj[index].finalbillhr = e.target.value;
        }

        // if(name == 'finalbillmin'){
        //     newobj[index].finalbillmin = e.target.value;
        // }
        setAutoobj(newobj); 
    }

    function saveautochange(value){
        console.log("save auto change");
        value.billingtypemodel = billingtypevar;
        if(formData.services == 'bk'){
            value.services = 'Bookkeeping'
        }

        if(formData.date == ''){
            toast.current.show({severity:'error', summary: "Field required", detail:`Month is required, select month from above dropdown`, life: 3000});   
            return;   
        }

        if(value.client == ''){
            toast.current.show({severity:'error', summary: "Field required", detail:`Client is required`, life: 3000});   
            return;
        }  

        let date = formatterhelper.dateformatter({date:formData.date});
        let obj = {'data' : value,'date':date}
        obj = JSON.stringify(obj);
        // return;
        // updatesubclientadjustmanual
        try{
            timesheetService.savemanual({formdata:obj}).then((response)=>{
                if(response.status == 200){
                    toast.current.show({severity:'success', summary: "Manual Final bill Approval", detail:`Bill Updated`, life: 3000});    
                    // getsubclientadjustmanual();
                    getmanualdata();
                    
                }else{
                    toast.current.show({severity:'error', summary: "Manual Final bill Approval", detail:`Not Updated`, life: 3000});    
                    getmanualdata();
                }

            }).catch((error)=>{
                toast.current.show({severity:'error', summary: "Manual Final bill Approval", detail:`Error`, life: 3000});    
                getmanualdata();
            });
        }catch(error){
        console.log(error); 
        }
    }

    function getmanualdata(){
        try{
            let data = {
            'client':formData.client,
            'date':formatterhelper.dateformatter({date:formData.date}),
            }; 
            
            timesheetService.getmanualdata({formdata:data}).then((response)=>{
                if(response.status == 200){
                    // console.log("response data");
                    // console.log(response.data.data);
                    setAutoobj(response.data.data);
                    setloading(true);
                    // console.log(response.data.data[0].billingtypemodel);
                    if(response.data.data.length > 0){
                        setbillingtype(response.data.data[0].billingtypemodel); 
                        let finalbillinitial = 0;
                        response.data.data.forEach((value,index)=>{
                           console.log("value data");     
                           console.log(value.finalbillhr);  
                           finalbillinitial = finalbillinitial + value.finalbillhr;   
                        }); 
                        setManualfinalbill({finalbillhr:finalbillinitial});
                    }
                    // setAutoobj();
                }else{
                    setAutoobj([auobj]);
                    setloading(true);
                    setManualfinalbill({finalbillhr:0});
                }
            }).catch((error)=>{
                setAutoobj([auobj]);
                setloading(true);
                setManualfinalbill({finalbillhr:0});
            });  
        }catch(Error){
            setAutoobj([auobj]);
            setloading(true);
            setManualfinalbill({finalbillhr:0});
        }
    }

    function addautoobj(){
        let tempobj = [...autoobj,auobj];
        console.log(tempobj);
        setAutoobj(tempobj);
    }

    function removeautoobj(key){
        let newobj = [...autoobj];
        // console.log("id");  
        // newobj.splice(key, 1);
        // console.log(newobj,'new object');
        // console.log(key);
        setAutoobj(newobj);    
    }

    const reject = () => {
    }

    function removeautoobjdb(value){
        confirmDialog({
        message: 'Are you sure you want to proceed?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        defaultFocus: 'accept',
        accept: () => {
            timesheetService.removeautoobjdb(value).then((response)=>{
                if(response.status == 200){
                    toast.current.show({severity:'success', summary: "Final bill", detail:`Deleted successfully`, life: 3000});    
                    //  getsubclientadjustmanual();
                }else{
                    toast.current.show({severity:'error', summary: "Final bill", detail:`No deleted`, life: 3000});    
                }
            }).catch((error)=>{
                toast.current.show({severity:'error', summary: "Final bill", detail:`Error`, life: 3000});     
            }); 
        },
        reject
    }); 
    }


    function searchqaclient(e,type=''){
            let value = e.target.value; 
         
            if(type == ''){
               
                let _clientlist = reportsliststemp;
                const searchRegexClient    = new RegExp(value.toLowerCase());
                const searchRegexSubclient = new RegExp(value.toLowerCase());
                //  console.log(value);
                // console.log('this section');
                // return; 
                const foundItems = _clientlist.filter(item => 
                //   (searchRegexClient.test(item.client) && searchRegexSubclient.test(item.subclient))
                (searchRegexClient.test(item?.client?.toLowerCase()) || searchRegexSubclient.test(item?.subclient?.toLowerCase()) || searchRegexSubclient.test(item?.subclient)     
                )
                );
    
                if (foundItems.length > 0) {
                    setReportslists(foundItems);
                } else {
                    setReportslists(reportsliststemp);
                }      
            }
            
    }


    function calculateFinalBillHours(approvalHrs, manualHrs) {
    try {
        // Convert to numbers
        const a = Number(approvalHrs);
        const b = Number(manualHrs);

        // Validation
        if (isNaN(a) || isNaN(b)) {
            throw new Error("Invalid input: values must be numbers");
        }

        if (a < 0 || b < 0) {
            throw new Error("Hours cannot be negative");
        }

        // Calculate and round (2 decimal places)
        const result = Math.round((a + b) * 100) / 100;

        return result;

    } catch (error) {
        console.error(error.message);
        return 0; // fallback value
    }
}

    return (
        <>
            <Toast ref={toast} />
            <div className="invisible-divider-sm"></div>
            <h6>Final bill Reports</h6>
            
            <div className='card card-custom-style card-style-padding'>
              <form onSubmit={handleSubmit}>
                <div className='row'>
                    <div className="col-md-2">
                        <label className='pull-left'>Select Month</label>
                        <Calendar view="month" name="date" onChange={handleChange} className='calender-custom-style' />
                        {errors.date && <span className='error'>{errors.date}</span>}
                    </div>

                    <div className="col-md-2">
                        <label className='pull-left'>Select Client </label>
                        <select className='form-control' name='client'  onChange={handleChange}>
                            <option value='ALL'>ALL</option>
                            {cleintscomp}
                        </select>
                        {errors.client && <span className='error'>{errors.client}</span>}
                    </div>

                    <div className="col-md-2">
                        <label className='pull-left'>Select Services</label>
                        <select className='form-control' name="services" onChange={handleChange}>
                            <option value=''>select service</option>
                            {(userdata.project == 'Bookkeeping' || userdata.roletype == 'admin') || roledata.rolename == 'superadmin' ? (<option value='bk'>Bookkeeping</option>) :(<></>) } 
                            {(userdata.project == 'Year End' || userdata.roletype == 'admin') || roledata.rolename == 'superadmin' ? (<option value='ye'>Year End</option>) :(<></>) }
                        </select>
                        {errors.services && <span className='error'>{errors.services}</span>}
                    </div>


                   
                    <div className="col-md-2">
                        <div className='button-wrapper-style'>
                            <Button type='submit' stype="button" label="Show" severity="success" rounded className='custom-btn-style' />
                            &nbsp;&nbsp;&nbsp; 
                            <Button type='button' stype="button" label="Export" severity="info" rounded className='custom-btn-style' onClick={()=>exportexcel()} />
                        </div>
                        
                    </div>
                   
                </div>
                </form>
            </div>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
              {reportslists.length > 0 ? (<div className='row' >
                    <div className='col-md-12'> 
                        <div className='row'>
                       <div className='container-box col-md-9' style={{alignItems: 'center'}}>
                       <div style={{
                           display: 'flex',
                           alignItems: 'center',
                           borderRadius: '4px',
                           overflow: 'hidden',
                           height: '38px',
                           background: '#fff8eb',
                       }}>
                           <div style={{
                               display: 'flex',
                               alignItems: 'center',
                               justifyContent: 'center',
                               padding: '0 10px',
                               height: '100%',
                               background: '#fef3c7',
                           }}>
                               <input type="checkbox" checked={ismulticheckeddata.some(v => v === true)} onChange={(e) => ismultichecked(e)} style={{ width: '16px', height: '16px', cursor: 'pointer', accentColor: '#f59e0b' }} />
                           </div>
                           <button
                               type="button"
                               onClick={() => multiapprove()}
                               style={{
                                   background: '#f59e0b',
                                   border: 'none',
                                   padding: '0 16px',
                                   fontWeight: 600,
                                   fontSize: '13px',
                                   color: '#ffffff',
                                   cursor: 'pointer',
                                   height: '100%',
                                   whiteSpace: 'nowrap',
                               }}
                           >
                               Multi Approve
                           </button>
                       </div>
                       &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                       {/* <Button type="button" onClick={() => sendtofinance()}  label="Send to Finance" severity="success" rounded className='custom-btn-style pull-left btn-height' /> */}
                       &nbsp;&nbsp;

                      {/* <div className='checkbox-container sendfinance'>
                        <input type="checkbox"/>  
                      </div> */}
                       <div className="card flex justify-content-center">
                            <ToggleButton style={{width: '200px',height: '38px'}} onLabel="Lock / Unlock" offLabel="Lock / Unlock" invalid onIcon={<FaUnlock/>} offIcon={<FaLock/>} checked={true} onChange={(e) => {lockmulti()}} className="w-8rem" />
                        </div>
                        &nbsp;&nbsp;
                        &nbsp;&nbsp;
                        &nbsp;&nbsp;
                        <div style={{ display:'flex', alignItems:'center', borderRadius:'4px', overflow:'hidden', height:'38px', background:'#22c55e' }}>
                            <div style={{ display:'flex', alignItems:'center', justifyContent:'center', padding:'0 10px', height:'100%', background:'#dcfce7' }}>
                                <input type="checkbox" checked={islockeddataislocked.lock} onChange={(e) => ismultilockchecked(e.target.checked)} style={{ width:'16px', height:'16px', cursor:'pointer', accentColor:'#22c55e' }} />
                            </div>
                            <span style={{ padding:'0 14px', fontWeight:600, fontSize:'13px', color:'#ffffff', whiteSpace:'nowrap', height:'100%', display:'flex', alignItems:'center', background:'#22c55e' }}>Lock</span>
                        </div>
                        &nbsp;&nbsp;
                        <div style={{ display:'flex', alignItems:'center', borderRadius:'4px', overflow:'hidden', height:'38px', background:'#ef4444' }}>
                            <div style={{ display:'flex', alignItems:'center', justifyContent:'center', padding:'0 10px', height:'100%', background:'#fee2e2' }}>
                                <input type="checkbox" checked={islockeddataislocked.unlock} onChange={(e) => ismultilockchecked2(e.target.checked)} style={{ width:'16px', height:'16px', cursor:'pointer', accentColor:'#ef4444' }} />
                            </div>
                            <span style={{ padding:'0 14px', fontWeight:600, fontSize:'13px', color:'#ffffff', whiteSpace:'nowrap', height:'100%', display:'flex', alignItems:'center', background:'#ef4444' }}>Unlock</span>
                        </div>
                       &nbsp;&nbsp;
                       &nbsp;&nbsp;

                        {formData.services != 'ye' && formData.services != '' ? ( <select className='custom-dropdown-style2 btn-height' value={billingtypevar} onChange={(e)=>{billingtype(e)}}>
                                <option value="">Select Billing</option>
                                <option value="Agreed Billing">Agreed Billing</option>
                                <option value="Budget">Budget</option>
                            </select>) : (<></>)}
                           
                       </div>
                              <div className='col-md-3'>
                                  <div className='search-input-wrapper'>
                                     <input id="finalbill-search-input" type="text" className='form-control' placeholder='Search by Client Or Subclient' onKeyUp={(e) => searchqaclient(e,'')}/>
                                     <FaSearch className='search-icon' onClick={() => { const el = document.getElementById('finalbill-search-input'); if(el) searchqaclient({target:el},''); }} />
                                  </div>
                              </div>
                       </div>
                    </div>
                    
                    {/* <div className='pagination col-md-6'>
                       
                        {isloaded && dataavail ? (<Paginator first={first} rows={rows} totalRecords={totalpages} rowsPerPageOptions={[15]} onPageChange={onPageChange} />) : (<></>)}
                        
                    </div> */}
                </div>) : (<></>) }
               
                <div className='row'>
                    <div className='col-md-12' style={{paddingLeft: 0}}>
                        <br/>
                        <div>
                            <div>
                                {reportslists.length > 0 && formData.client != 'ALL' && formData.services != 'ye' ? ( <div style={{background:'#efefef'}} className='container-box custom-card-styles'>
                                    <span> <b>Client </b> : {manauladata.client} </span>
                                    &nbsp; | &nbsp;
                                    <span> <b>Budget </b> : {manauladata.budget}</span>
                                    </div> ) :  <> </>}

                             </div>
                             <div>
                                 {!isloaded ? loader.Loadermd() : (reportslists.length > 0 ? (<div className='container-box custom-card-styles'>
                                    <span style={{fontSize:'18px'}}><FaCheck className='edit-btn-style'/> Approved : {approvaldata.approved} </span>
                                    &nbsp;
                                    &nbsp;
                                    <span style={{fontSize:'18px'}}> <FaTrashAlt className='error'/> Not Approved : {approvaldata.notapproved} </span>
                                    &nbsp;
                                    &nbsp;
                                    <span style={{fontSize:'18px'}}><FaLock/> Locked : {approvaldata.locked} </span>
                                    &nbsp;
                                    &nbsp;
                                    <span style={{fontSize:'18px'}}><FaUnlock/> Unlocked : {approvaldata.unlocked} </span>

                                    &nbsp;
                                    <span style={{fontSize:'18px',color:'#2db9e3'}}> | ActualHr : {approvaldata.actualhours} </span> 
                                    &nbsp;
                                    <span style={{fontSize:'18px',color:'#2db9e3'}}> | BillHr : {approvaldata.sumbilledhrs} </span>
                                    &nbsp;
                                    <span style={{fontSize:'18px',color:'#2db9e3'}}> | Finalbill : {calculateFinalBillHours(approvaldata.finalbillhrs, manualfinalbill.finalbillhr)} </span>
                                    &nbsp;
                                    <span style={{fontSize:'18px',color:'#d74113'}}> | Lockedhours : {approvaldata.lockedhours} </span>
                                    &nbsp;
                                    <span style={{fontSize:'18px',color:'#198754'}}> | UnLockedhours : {approvaldata.unlockedhours} </span>
                                    </div>) : (<></>))}
                             </div>
                        </div>

                          
                        {/* </div> */}
                       
                       <br/>   
                    </div>
                    <div className='col-md-12'>
                      {!isloaded ? loader.Loadermd() : (reportslists.length == 0 && autoobj.length == 0) ? <Nodataprimecomp /> :  (
                            <table class="table table-bordered" id="finalaprovalbill-table-id">
                            <thead>
                                <tr>
                                    <th scope="col" style={{width:'30px'}}>Sr no</th>
                                    {/* <th scope="col">Userid</th> */}
                                    <th scope="col" style={{width:'100px'}}>Client</th>
                                    <th scope="col" style={{width:'100px'}}>SubClient</th>
                                    <th scope="col" >Actual Hrs</th>
                                    <th scope="col" >Billing Hr</th>
                                    <th scope="col" >Final Bill Hrs</th>
                                    <th scope="col"> Services</th>
                                    {formData.services == 'bk' ? (<th scope="col">Remarks</th>) : (<></>)}
                                    {/* <th scope="col" style={{width:'30px'}}>Send for Finance</th> */}
                                    {formData.services == 'bk' ? (<th scope="col">Billing type</th>) : (<></>)}
                                    <th scope="col">Islocked</th>
                                    <th scope="col">Actions</th>
                                    <th scope="col">Workflow <br/>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {displaybkreport()}
                                {userdata.project == 'Bookkeeping' ? autoobjData() : (<></>)}
                            </tbody>
                        </table> 
                        )}
                    </div>
                    {/* : (<p>No data Found</p>)}  */}
                </div>
            </div>

            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default Finalbillapproval;